import { PayloadAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TGetConversionFinalDraftsSummaryAPIParams } from '~types/feat/gold';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetGoldConversionFinalDraftsSummary(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetGoldConversionFinalDraftsSummaryAttempt', handleGetGoldConversionFinalDraftsSummary, api);
}

function* handleGetGoldConversionFinalDraftsSummary(api: GoldGateway, action: PayloadAction<TGetConversionFinalDraftsSummaryAPIParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { id } = action.payload;

    const response = yield* call([api, api.getGoldConversionFinalDraftsSummary], {
        authToken,
        id,
    });

    if (response.status === GatewayResponseStatus.Error) {
        toast.error(response.message || ErrorMessages.GoldCreateTransactionError);
        yield put(combinedActions.goldGetConversionFinalDraftsSummaryFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldGetConversionFinalDraftsSummarySuccess(response.data));
    }
}
